import "./PDFViewer.scss";

export default function PDFViewer(props) {
  return (
    <div className="pdf-viewer">
      <div className="pdf-container">
        <iframe
          src={props.fileURL}
          title={props.title || "PDF Viewer"}
          style={props.style || { border: "none", width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
}
